import React from 'react';

import EN from './EN';

/**
 * 订阅服务协议组件
 * 暂时中英文都使用英文版本
 */
export const SmartSubscriptionAgreement: React.FC = () => {
  return <EN />;
};

export default SmartSubscriptionAgreement;
